export default "December 19, 2022";